import { useSelector } from 'react-redux'
import { isActiveWorkSkill } from '../../utils/workskills'

export default () => {
  const artifactCriteria = useSelector(
    state => state.assessment.artifactAssessmentCriteria
  )

  const workSkills = artifactCriteria.filter(isActiveWorkSkill)

  return workSkills
}
